import { api, generateCRUDInterface } from "aldoo-ra/API"
//construct the endpoint
const crudAPI = api("crud")

//Given the crud API, generate the CRUD interface
const crud = generateCRUDInterface(crudAPI, "StoreProduct")

//override the get method to populate the price
crud.Get = async (get) => {
  // Convert DataTable sort format { field, order } → MongoDB { field: 1/-1 }
  let sort = get.sort
  let clientSideSort = null

  if (sort?.field) {
    if (sort.field === "price_model") {
      // Price is a populated ref — sort client-side after fetch
      clientSideSort = sort.order === "asc" ? 1 : -1
      sort = { created: -1 } // fallback server sort
    } else {
      sort = { [sort.field]: sort.order === "asc" ? 1 : -1 }
    }
  }

  get = {
    ...get,
    sort,
    model: "StoreProduct",
    populate: [
      {
        path: "price", // Populate main product price
      },
      {
        path: "licenseModel", // Populate license model
      },
      {
        path: "bundle.product", // Populate bundle products
        populate: {
          path: "price", // And their prices
        },
      },
      {
        path: "bundle.price", // Populate bundle item price overrides
      },
    ],
    //filter out deleted items
    ...{ match: { ...get.match, deleted: { $ne: true } } },
  }
  const result = await crudAPI({ get })

  if (clientSideSort && Array.isArray(result)) {
    result.sort((a, b) => {
      const aAmount = parseFloat(a.price?.price_model?.find(p => p.primary)?.amount ?? a.price?.price_model?.[0]?.amount ?? 0)
      const bAmount = parseFloat(b.price?.price_model?.find(p => p.primary)?.amount ?? b.price?.price_model?.[0]?.amount ?? 0)
      return (aAmount - bAmount) * clientSideSort
    })
  } else if (clientSideSort && result?.data) {
    result.data.sort((a, b) => {
      const aAmount = parseFloat(a.price?.price_model?.find(p => p.primary)?.amount ?? a.price?.price_model?.[0]?.amount ?? 0)
      const bAmount = parseFloat(b.price?.price_model?.find(p => p.primary)?.amount ?? b.price?.price_model?.[0]?.amount ?? 0)
      return (aAmount - bAmount) * clientSideSort
    })
  }

  return result
}

// Add custom methods for restore functionality
const GetDeleted = async (get) => {
  get = {
    ...get,
    model: "StoreProduct",
    populate: [
      {
        path: "price", // Populate main product price
      },
      {
        path: "licenseModel", // Populate license model
      },
      {
        path: "bundle.product", // Populate bundle products
        populate: {
          path: "price", // And their prices
        },
      },
      {
        path: "bundle.price", // Populate bundle item price overrides
      },
    ],
    //filter to show only deleted items
    match: { ...get.match, deleted: true },
    // Preserve sort parameter (defaults to deletedAt descending if not provided)
    sort: get.sort || { deletedAt: -1 },
  }
  return await crudAPI({ get })
}

const Restore = async (id) => {
  const update = {
    model: "StoreProduct",
    data: { _id: id, deleted: false, deletedAt: null }
  }
  return await crudAPI({ update })
}

export default {
  ...crud,
  GetDeleted,
  Restore,
}
